import React from 'react'
import { Toast, ToastBody, ToastHeader } from 'reactstrap'

const PushNotification = ({ title, message, toggle, icon = null }) => (
  <Toast className='push-notifications__notification'>
    <ToastHeader icon={icon} toggle={toggle}>
      {title}
    </ToastHeader>
    <ToastBody>{message}</ToastBody>
  </Toast>
)

export default PushNotification
